import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

import { AdminMenuPriviliges } from "../priviligesProviders/AdminMenuPriviligesProvider";
import { WorkerMenuPriviliges } from "../priviligesProviders/WorkerMenuPriviligesProvider";
import { WorkplaceMenuPriviliges } from "../priviligesProviders/WorkplaceMenuPriviligesProvider";
import { NavigationMenu } from "./types";
import { getAdminNavigationMenu } from "./useGetAdminNavigationMenu";
import { getWorkerNavigationMenu } from "./useGetWorkerNavigationMenu";
import { getWorkplaceNavigationMenu } from "./useGetWorkplaceNavigationMenu";

interface NavigationMenuOptions {
  unreadChannelCount?: number;
}

export function useGetNavigationMenu(
  isAdmin: boolean,
  adminMenuPriviliges: AdminMenuPriviliges,
  isWorker: boolean,
  workerMenuPriviliges: WorkerMenuPriviliges,
  isWorkplace: boolean,
  workplaceMenuPriviliges: WorkplaceMenuPriviliges,
  currentPath: string,
  options: NavigationMenuOptions = {}
): NavigationMenu {
  const analyticsConfig = useCbhFlag(CbhFeatureFlag.FACILITY_EXPLO_ANALYTICS_ENABLED, {
    defaultValue: [],
  });

  if (isAdmin) {
    return getAdminNavigationMenu(adminMenuPriviliges, currentPath);
  } else if (isWorker) {
    return getWorkerNavigationMenu(workerMenuPriviliges, currentPath);
  } else if (isWorkplace) {
    return getWorkplaceNavigationMenu(workplaceMenuPriviliges, currentPath, analyticsConfig, {
      unreadChannelCount: options.unreadChannelCount,
    });
  } else {
    return { items: [] };
  }
}
